import { comics } from '@/mocks/comics';
import ComicCard from '@/components/base/ComicCard';

export default function LatestUpdates() {
  const latest = [...comics].sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()).slice(0, 8);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6">
      <div className="max-w-[1280px] mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900">
            最新更新
          </h2>
          <p className="text-sm text-foreground-500 mt-2">每日新鲜内容，追更不等待</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
          {latest.map((comic) => (
            <div key={comic.id}>
              <ComicCard comic={comic} size="medium" />
              <div className="mt-2">
                <p className="text-xs text-foreground-500">
                  更新至 {comic.chapters[comic.chapters.length - 1]?.title || ''}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}